module.exports = __webpack_public_path__ + "img/tanoto.9570ed68.png";